import React from "react";
// Ícones para destacar seus pontos fortes
import { Leaf, Truck, Heart } from "lucide-react"; 
import missaoImg from "../assets/image/fotoUsuario.jpg"; // Mantenha o caminho da sua imagem

// Texto de introdução, extraído da sua descrição
const introText = `A Insetobras é uma empresa dedicada à criação de insetos como tenebrios, grilos e baratas. Iniciada em 14 de maio de 2021, começamos pequenos e continuamos investindo em uma estrutura cada vez melhor. Estamos 100% dedicados não apenas em criar insetos, mas em proporcionar ao cliente uma experiência prazerosa ao alimentar seus animais.`;

// Seus pontos fortes, extraídos da descrição, agora em formato de "features"
const features = [
  {
    icon: <Leaf className="w-10 h-10 text-orange-500" />,
    title: "Qualidade Orgânica",
    description: "Nossos insetos são nutridos com farelo de trigo e verduras orgânicas que nós mesmos plantamos, assegurando animais saudáveis e bem nutridos para seu pet.",
  },
  {
    icon: <Truck className="w-10 h-10 text-orange-500" />,
    title: "Entrega e Praticidade",
    description: "Entregamos gratuitamente em todo o DF e atendemos o Brasil via transportadora. Nossos produtos vão em vasilhas prontas para uso, com furos e ração inclusa.",
  },
  {
    icon: <Heart className="w-10 h-10 text-orange-500" />,
    title: "Compromisso Social",
    description: "Dedicamos 10% do valor bruto de cada venda ao hospital da criança com câncer ABRACE, situado no Setor Militar Urbano de Brasília.",
  },
];

export default function QuemSomos() {
  return (
    <>
      {/* Seção 1: Introdução */}
      <section className="bg-white py-16 sm:py-24" id="quemsomos">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            
            {/* Coluna de Texto */}
            <div className="text-gray-700">
              <h2 className="text-base font-semibold uppercase tracking-wide text-green-700">
                Nossa História
              </h2>
              <h1 className="mt-2 text-4xl sm:text-5xl font-extrabold text-green-900 tracking-tight">
                Apaixonados pelo que fazemos
              </h1>
              <p className="mt-6 text-lg leading-relaxed">
                {introText}
              </p>
            </div>

            {/* Coluna da Imagem */}
            <div className="mt-10 lg:mt-0">
              <img
                src={missaoImg}
                alt="Equipe InsetoBras"
                className="w-full rounded-2xl shadow-2xl transition-all duration-500 transform hover:shadow-3xl hover:-translate-y-1 hover:scale-105"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Seção 2: Nossos Pilares (Features) */}
      <section className="bg-gray-50 py-16 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl font-extrabold text-green-900">
              Nossos Pilares
            </h2>
            <p className="mt-4 text-lg text-gray-600">
              Qualidade, praticidade e responsabilidade em tudo que fazemos.
            </p>
          </div>

          {/* Grid de Features */}
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-10">
            {features.map((feature) => (
              <div 
                key={feature.title} 
                className="bg-white p-8 rounded-xl shadow-lg transition-all duration-300 transform hover:shadow-2xl hover:-translate-y-2"
              >
                <div className="flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-6">
                  {feature.icon}
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  {feature.description}
                </p>    
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
